export default __webpack_public_path__ + "static/media/benefits1New.43ec55cb.gif";